import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setArray,
  decreaseUnreadCount
} from 'store/redux/notifications'

export default function * requestMarkAllNotificationsAsRead (action) {
  const state = yield select()

  const unreadCount = state.kanbo.notifications.unreadCount

  let array = []
  let currentArray = []

  state.kanbo.notifications.notifications.forEach(id => {
    const wasRead = state.kanbo.notifications.notificationsById[id].wasRead
    if (!wasRead) {
      array.push({ id, wasRead: true })
      currentArray.push({ id, wasRead })
    }
  })

  const optimisticAction = yield optimisticPut(setArray(array))
  const optimisticAction2 = yield optimisticPut(decreaseUnreadCount({
    unreadCount
  }))

  try {
    yield call(apiAction, 'MarkAllNotificationsAsRead')

    yield optimisticAction.commit()
    yield optimisticAction2.commit()
  } catch (error) {
    yield optimisticAction.revert()
    yield optimisticAction2.revert()

    throw error
  }
}

